export const CHAMADOS_DESIGN = {
    page: {
        container: "h-full bg-slate-100 flex flex-col overflow-hidden animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            wrapper: "sticky top-0 z-20 bg-white/80 dark:bg-[#222529]/80 backdrop-blur-md border-b border-gray-100/50 dark:border-[#383838]/50 px-6 py-4 shadow-sm",
            inner: "flex flex-col md:flex-row md:items-center justify-between gap-4",
            left: "flex flex-wrap items-center gap-4",
            iconBox: "p-2 bg-[#7C3AED]/10 rounded-lg",
            icon: "text-[#7C3AED]",
            title: "text-sm font-semibold text-gray-900 dark:text-[#D1D2D3]",
            subtitle: "text-[10px] text-gray-500 dark:text-[#ABABAD]",
            divider: "h-8 w-px bg-gray-200 hidden md:block",
            right: "flex items-center gap-3",
        },
        viewToggle: {
            container: "flex items-center bg-gray-100 dark:bg-[#1A1D21] p-1 rounded-lg border border-gray-200 dark:border-[#383838] h-9",
            button: {
                base: "flex items-center px-3 py-1 rounded-md transition-all text-xs font-medium",
                active: "bg-white shadow-sm text-gray-900 dark:text-[#D1D2D3]",
                inactive: "text-gray-500 dark:text-[#ABABAD] hover:text-gray-900 dark:hover:text-[#D1D2D3]",
            },
            icon: "mr-1.5",
        },
        actionButton: "h-9 bg-[#7C3AED] hover:bg-[#6D28D9] text-white text-xs font-medium px-4 transition-all rounded-lg flex items-center gap-1.5",
    },
    stats: {
        grid: "grid grid-cols-2 md:grid-cols-4 gap-3 px-4 py-4",
        card: "bg-white rounded-xl border border-gray-100 dark:border-[#383838] p-4 flex items-center gap-3",
        iconBox: {
            base: "w-10 h-10 rounded-xl flex items-center justify-center",
            violet: "bg-violet-50 dark:bg-violet-500/10",
            amber: "bg-amber-50 dark:bg-amber-500/10",
            blue: "bg-blue-50 dark:bg-blue-500/10",
            red: "bg-red-50 dark:bg-red-500/10",
        },
        icon: {
            violet: "text-violet-600 dark:text-violet-400",
            amber: "text-amber-600 dark:text-amber-400",
            blue: "text-blue-600 dark:text-blue-400",
            red: "text-red-600 dark:text-red-400",
        },
        value: "text-xl font-bold text-gray-900 dark:text-[#D1D2D3]",
        label: "text-xs text-gray-500 dark:text-[#ABABAD]",
    },
    filters: {
        container: "px-4 pb-4",
        inner: "grid grid-cols-1 md:grid-cols-3 gap-4",
        label: "text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider mb-2",
    },
    kanban: {
        container: "flex-1 overflow-hidden px-4 pb-4",
        scrollArea: "h-full",
        columnsRow: "flex flex-row items-start gap-4 h-full pb-4 overflow-x-auto",
        column: "flex-1 min-w-[260px] md:min-w-[300px] h-full",
        columnCard: {
            base: "flex flex-col h-full rounded-2xl overflow-hidden border",
            pendente: "bg-amber-50/30 dark:bg-amber-500/5 border-amber-100 dark:border-amber-500/20",
            aberto: "bg-blue-50/30 dark:bg-blue-500/5 border-blue-100 dark:border-blue-500/20",
            recusado: "bg-red-50/30 dark:bg-red-500/5 border-red-100 dark:border-red-500/20",
        },
        columnHeader: {
            wrapper: "p-4 pb-3",
            inner: "flex items-center justify-between",
            left: "flex items-center gap-3",
            iconBox: {
                base: "p-2 rounded-xl",
                pendente: "bg-amber-100 dark:bg-amber-500/20",
                aberto: "bg-blue-100 dark:bg-blue-500/20",
                recusado: "bg-red-100 dark:bg-red-500/20",
            },
            icon: {
                pendente: "text-amber-600 dark:text-amber-400",
                aberto: "text-blue-600 dark:text-blue-400",
                recusado: "text-red-600 dark:text-red-400",
            },
            title: "text-sm font-bold text-gray-800 dark:text-[#D1D2D3] uppercase tracking-widest leading-none mb-0.5",
            count: {
                base: "text-[11px] font-bold px-2 py-0.5 rounded-full",
                pendente: "bg-amber-100 dark:bg-amber-500/20 text-amber-700 dark:text-amber-400",
                aberto: "bg-blue-100 dark:bg-blue-500/20 text-blue-700 dark:text-blue-400",
                recusado: "bg-red-100 dark:bg-red-500/20 text-red-700 dark:text-red-400",
            },
        },
        columnContent: "flex-1 min-h-0 relative",
        columnScrollArea: "h-full w-full",
        columnList: "p-3 pt-1 flex flex-col gap-2.5",
        columnEmpty: "flex flex-col items-center justify-center py-10 text-center",
        columnEmptyIcon: "w-10 h-10 rounded-full bg-gray-100 dark:bg-[#383838] flex items-center justify-center mb-2 mx-auto text-gray-300 dark:text-[#ABABAD]",
        columnEmptyText: "text-xs text-gray-400 dark:text-[#ABABAD]",
    },
    kanbanLabels: {
        pendente: "Pendentes",
        aberto: "Abertos",
        recusado: "Fechados",
    },
    lista: {
        container: "flex-1 flex flex-col min-h-0 px-4 pb-4",
        card: "flex-1 flex flex-col min-h-0 bg-white dark:bg-[#222529] rounded-xl border border-gray-100 dark:border-[#383838] shadow-sm overflow-hidden",
        statusTabs: {
            container: "px-4 pt-3 pb-0",
            list: "bg-muted",
        },
        pagination: {
            container: "flex items-center justify-between px-4 py-3 border-t border-gray-100 dark:border-[#383838]",
            left: "flex items-center gap-2",
            right: "flex items-center gap-2",
            label: "text-sm text-gray-500 dark:text-[#ABABAD]",
            info: "text-sm text-muted-foreground",
        },
    },
    detalhes: {
        container: "flex-1 flex overflow-hidden",
        sidebar: "w-full md:w-[320px] md:min-w-[280px] flex-shrink-0",
        content: "flex-1 flex flex-col min-w-0 bg-white dark:bg-[#1A1D21] relative",
        emptyContent: "flex flex-col items-center justify-center h-full p-12 text-center bg-gray-50 dark:bg-[#1A1D21]",
        emptyIconBox: "w-16 h-16 bg-gray-100 dark:bg-gray-800 rounded-2xl flex items-center justify-center mb-5 text-gray-300 dark:text-gray-600",
        emptyTitle: "text-base font-bold text-gray-900 dark:text-gray-100 mb-1.5",
        emptyDescription: "text-sm text-gray-500 dark:text-gray-400 max-w-sm",
    },
    emptyState: {
        container: "flex flex-col items-center justify-center p-12 bg-white rounded-xl border border-gray-100 dark:border-[#383838] border-dashed text-center h-full",
        iconBox: "w-16 h-16 bg-gray-50 dark:bg-[#383838] rounded-full flex items-center justify-center mb-4 text-gray-400 dark:text-[#ABABAD]",
        title: "text-lg font-semibold text-gray-900 dark:text-[#D1D2D3] mb-1",
        description: "text-gray-500 dark:text-[#ABABAD] max-w-sm mb-6",
        link: "text-[#7C3AED] font-medium hover:underline text-sm",
    },
    badges: {
        pendente: {
            container: "text-xs font-medium flex items-center gap-1.5 bg-amber-50 dark:bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-200 dark:border-amber-500/30",
            dot: "w-1.5 h-1.5 rounded-full bg-amber-500",
        },
        aberto: {
            container: "text-xs font-medium flex items-center gap-1.5 bg-blue-50 dark:bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-200 dark:border-blue-500/30",
            dot: "w-1.5 h-1.5 rounded-full bg-blue-500",
        },
        recusado: {
            container: "text-xs font-medium flex items-center gap-1.5 bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-400 border-red-200 dark:border-red-500/30",
            dot: "w-1.5 h-1.5 rounded-full bg-red-500",
        },
        concluido: {
            container: "text-xs font-medium flex items-center gap-1.5 bg-green-50 dark:bg-green-500/10 text-green-700 dark:text-green-400 border-green-200 dark:border-green-500/30",
            dot: "w-1.5 h-1.5 rounded-full bg-green-500",
        },
        cancelado: {
            container: "text-xs font-medium flex items-center gap-1.5 bg-gray-50 text-gray-600 dark:text-[#ABABAD] border-gray-200 dark:border-[#565856]",
            dot: "w-1.5 h-1.5 rounded-full bg-gray-400",
        },
    },
    row: {
        container: "group px-6 py-4 flex items-center border-b last:border-b-0 border-gray-100 dark:border-[#383838] hover:bg-gray-50/50 dark:hover:bg-[#383838]/50 transition-colors cursor-pointer",
        containerLate: "group px-6 py-4 flex items-center border-b last:border-b-0 border-gray-100 dark:border-[#383838] hover:bg-red-50/50 dark:hover:bg-red-500/10 transition-colors cursor-pointer bg-red-50/30 dark:bg-red-500/5",
    },
};
